export default class CopyUrl {
    constructor() {
        this.copyLink();
        this.copyData();
    }

    copyLink() {
        const btnCopyLink = document.querySelectorAll('.btnCopyLink');

        if (btnCopyLink) {
            btnCopyLink.forEach(btn => {
                btn.addEventListener('click', () => {
                    const url = window.location.href;
                    navigator.clipboard.writeText(url).then(() => {
                        console.log('URL copiada para o clipboard: ' + url);

                        // Exibir o label .labelCopyUrl
                        const label = btn.closest('li').querySelector('.labelCopyUrl');
                        if (label) {
                            label.classList.remove('hidden');

                            // Remover o label após 5 segundos
                            setTimeout(() => {
                                label.classList.add('hidden');
                            }, 5000);
                        }
                    }).catch(err => {
                        console.error('Erro ao copiar a URL: ', err);
                    });
                });
            });
        }
    }
    
    copyData() {
        const btnCopyData = document.querySelectorAll('.btnCopyData');

        if (btnCopyData) {
            btnCopyData.forEach(btn => {
                btn.addEventListener('click', () => {
                    const data = btn.dataset.copy;
                    navigator.clipboard.writeText(data).then(() => {
                        console.log('Texto copiado para o clipboard: ' + data);

                        // Exibir o label .labelCopyData
                        const label = btn.closest('.relative').querySelector('.labelCopyData');
                        if (label) {
                            label.classList.remove('hidden');

                            // Remover o label após 5 segundos
                            setTimeout(() => {
                                label.classList.add('hidden');
                            }, 5000);
                        }
                    }).catch(err => {
                        console.error('Erro ao copiar o texto: ', err);
                    });
                });
            });
        }
    }
}

new CopyUrl();
